import { useEffect } from "react";
import { PubSubActions } from "redux-store";
import { useDispatch } from "react-redux";
import { useNetworkStatus } from "hooks";

const HandlingPubSub = () => {
  const dispatch = useDispatch();
  const { triggerServerStatusCheck } = useNetworkStatus();
  useEffect(() => {
    dispatch(PubSubActions.initPubsub());

    // Lắng nghe sự kiện triggerServerStatusCheck
    const handler = event => {
      // Lấy payload từ event.detail
      const payload = event.detail;
      if (payload && payload.prefixKey) {
        triggerServerStatusCheck(payload.prefixKey, payload.isServerOnline);
      }
    };
    window.addEventListener("triggerServerStatusCheck", handler);

    return () => {
      // Ensure that all thead of logout branches are destroyed
      dispatch(PubSubActions.destroyLogoutBranchThread());
      window.removeEventListener("triggerServerStatusCheck", handler);
    };
  }, []);

  return null;
};
export default HandlingPubSub;
